import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
            toast.success("If that email exists, a reset link is on its way.");
        } catch (e) {
            toast.error("Could not send reset link");
        } finally { setLoading(false); }
    };

    return (
        <div className="min-h-[calc(100vh-6rem)] flex items-center justify-center px-6 py-10">
            <div className="w-full max-w-md rounded-4xl glass-strong p-8 relative overflow-hidden">
                <div className="ambient-orb bg-brand-peach -top-16 -left-16 w-56 h-56" />
                <div className="relative z-10 text-center">
                    <div className="mx-auto w-14 h-14 rounded-full bg-primary/10 text-primary flex items-center justify-center mb-4"><Mail className="w-6 h-6" /></div>
                    <h1 className="font-display text-2xl font-bold">Forgot password</h1>
                    <p className="text-sm text-muted-foreground mt-1">Enter your email to receive a reset link</p>
                    {sent ? (
                        <div className="mt-6 rounded-2xl bg-emerald-50 text-emerald-700 p-4 text-sm">Check your inbox — the link expires in 1 hour.</div>
                    ) : (
                        <form onSubmit={submit} className="mt-6 space-y-3">
                            <Input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-xl h-12 bg-white/60" />
                            <Button type="submit" disabled={loading} className="w-full rounded-full h-12 bg-primary hover:bg-primary/90">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}</Button>
                        </form>
                    )}
                    <div className="mt-5 text-sm"><Link to="/login" className="text-primary hover:underline">Back to login</Link></div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
